"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Regulator = void 0;
var constant_1 = require("../constant");
var Regulator = /** @class */ (function () {
    function Regulator(tokenizedList, hourSystemType) {
        // 临时变量
        this.subsecondMatchResult = null;
        this.lastParsedType = constant_1.TokenType.Text;
        // 结果变量
        this.subsecondDecimalNumber = 0;
        this.tokenizedList = tokenizedList;
        this.hourSystemType = hourSystemType;
        this.currentIndex = this.tokenizedList.length - 1;
    }
    /**
     * 对格式分词数组中的时间格式类型进行调整
     */
    // eslint-disable-next-line complexity, max-lines-per-function
    Regulator.prototype.run = function () {
        for (; this.currentIndex >= 0; this.currentIndex--) {
            this.currentToken = this.tokenizedList[this.currentIndex];
            switch (this.currentToken.type) {
                case constant_1.TokenType.HalfDayHours:
                case constant_1.TokenType.FullDayHours:
                    this.handleHour();
                    break;
                case constant_1.TokenType.Second:
                    this.handleSecond();
                case constant_1.TokenType.Day:
                case constant_1.TokenType.Year:
                case constant_1.TokenType.Minute:
                case constant_1.TokenType.Era:
                    // 不需要调整的时间格式记录为上一个解析的类型
                    this.handleOtherTimeRelated();
                    break;
                case constant_1.TokenType.Month:
                    this.handleMonth();
                    break;
                case constant_1.TokenType.SpecialStartGenesis:
                    // 特殊起始日期, 暂不处理
                    break;
                case constant_1.TokenType.AbsoluteTime:
                    // 绝对值进位, 暂不处理
                    break;
                default:
                    break;
            }
        }
    };
    /**
     * 返回调整过程中解析到的秒一下时间
     */
    Regulator.prototype.getRegulatedResult = function () {
        return this.subsecondDecimalNumber;
    };
    /**
     * 针对月份格式串
     */
    Regulator.prototype.handleMonth = function () {
        // 时间格式最大只能两个m
        if (this.lastParsedType === constant_1.TokenType.Second
            && String(this.currentToken.value).length <= 2) {
            this.currentToken.type = constant_1.TokenType.Minute;
        }
    };
    /**
     * 针对小时格式串
     */
    Regulator.prototype.handleHour = function () {
        this.currentToken.type = this.hourSystemType;
    };
    /**
     * 针对秒格式串
     */
    Regulator.prototype.handleSecond = function () {
        this.subsecondMatchResult = String(this.currentToken.value).match(/\.0+$/);
        if (this.subsecondMatchResult) {
            this.subsecondDecimalNumber = Math.max(this.subsecondDecimalNumber, this.subsecondMatchResult[0].length - 1);
        }
    };
    /**
     * 针对其他时间格式串
     */
    Regulator.prototype.handleOtherTimeRelated = function () {
        this.lastParsedType = this.currentToken.type;
    };
    return Regulator;
}());
exports.Regulator = Regulator;
//# sourceMappingURL=regulator.js.map